import React, { Component } from "react";

import DataTable from 'react-data-table-component';

import $ from "jquery";


const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage:true
};
export default class TarjetaCredito extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaTarjeta: [],
      importe: undefined
    };
  }

  componentDidMount() {
  
  }

 

  getColumn() {
    return [
      {
        name: "Tarjeta",
        selector: row => row.tarjeta,
        width: "180px",
      },
      {
        name: "Tipo",
        selector: row => row.tipo
      },
      {
        name: "Límite",
        selector: row => row.limite,
        width: "150px",
        right: true
      },
      {
        cell: (row) => (
          <input
            ref={() => this.grupoSel}
            id={"radio_" + row.id}
            type="radio"
            key={row.id}
            type="radio"
            name="rowRadio"
            value={row.id}
            onClick={this.selTCEvt}
          ></input>
        ),
        width: "50px",
      },
    ];
  }

  seleccionarFila(row){
   
    this.tcSele = document.getElementById("radio_" + row.id);
  
      this.props.datoTC(row.tarjeta, row.tipo, row.limite, row.nro);
    
  }


  selTCEvt = (e) => {

    this.tcSele = e.currentTarget;

    for (var i = 0; i < this.props.tarjeta.length; i++) {
      var tc = this.props.tarjeta[i]
      var tc_id = "radio_" + tc.id;
      if(tc_id === this.tcSele.id)
      this.props.datoTC(tc.tarjeta, tc.tipo, tc.limite, tc.nro);
    
    }
   
    this.enableNext();
  };
  enableNext() {


    this.checkGrilla();
   
  }

  checkGrilla() {
   // console.log("en check " + this.tcSele)
    if (this.tcSele !== undefined) {
      $("#" + this.tcSele.id).prop("checked", true);
    }
  
  }

  
  handleChangeSelector = (event) => {
    const valueToParse = event.target.value;
 
    this.setState({ importe: valueToParse });
   this.props.importePagar(valueToParse);
   
  }

  obtenerTarjeta() {
    if (this.props.tarjeta !== undefined && this.props.tarjeta.length === 0)
    return (
      <div>
        <span />
      </div>
    )
        return(
          <div>
            <div className="row">
              <div className="col-md-8">
                  <label className="input-label-bold">
                    Seleccione el importe a pagar *
                  </label> 
                  <select className="form-control input-box" onChange={this.handleChangeSelector}>
                    <option value="">-- Seleccione --</option>
                    <option value="1">5% de la deuda (Pago mínimo)</option>
                    <option value="2">100% de la deuda (Saldo cierre)</option>
                 
                  </select>
              </div>
            </div> 
            <br/>
            <div className="row"> 
              <div className="col-md-12">
                <label className="input-label-bold">
                  Seleccione la Tarjeta *
                </label>
                <div className="table-responsive">
                <DataTable
                  noHeader={true}
                  pagination={true}
                  columns={this.getColumn()}
                  data={this.props.tarjeta}
                  dense={true}
                  pagination={true}
                  paginationComponentOptions={paginationOptions}
                  noDataComponent="no hay registros para mostrar"
                  responsive={true}
                  striped={true}
                  onRowClicked={(e)=>this.seleccionarFila(e)}
                  pointerOnHover
                  />                       
                </div>   
              </div>                       
            </div> 
          </div>  
        )
  }
  

  render() {
    return (
      <div>
        <hr/>
        <div className="form-group">
          {this.obtenerTarjeta()}
        </div>
      </div>
    );
  }
}
